const expiredTokenMessage = 'Token expirado.'


export { expiredTokenMessage }


// WEBPACK FOOTER //
// ./src/const/poll/voteToken.js